/**
 * ShareListing — the share sheet for a single listing.
 *
 * A thin wrapper over `ShareBar`: it turns the listing's display facts
 * (price, beds, address...) into a share target with the listing caption
 * and the Instagram post kit, so PropertyCard, the public and admin
 * listing pages and the chat cards keep their one-line usage.
 */

import { ShareBar, type ShareBarVariant } from '@/components/common/ShareBar';
import { listingShareTarget, type ShareListingFacts } from '@/utils/share';

export interface ShareListingProps extends ShareListingFacts {
    /** Which gallery photo the Instagram kit saves. */
    photoIndex?: number;
    /**
     * `icon` is a bare button for tight spots (a card corner);
     * `button` is a labelled one; `stacked` matches the icon-over-caption
     * column on the public detail page.
     */
    variant?: Exclude<ShareBarVariant, 'inline'>;
    className?: string;
}

export function ShareListing({
    listingId,
    address,
    locality,
    price,
    beds,
    baths,
    sqft,
    photoIndex = 0,
    variant = 'button',
    className = '',
}: ShareListingProps) {
    const target = listingShareTarget({ listingId, address, locality, price, beds, baths, sqft }, photoIndex);
    return <ShareBar target={target} variant={variant} className={className} />;
}

export default ShareListing;
